<template>
  <div id="atendimentos-classificacao">
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Atendimentos classificação"
            description=""
            url=""
            :enabledModalInformacao="false"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao=""
            pageIdentifier="atendimentos-classificacao"
          />
        </div>
      </div>
      <ValidationObserver ref="form">
        <div class="row">
          <div class="col-lg-5">
            <validation-provider v-slot="{ errors }" rules="required">
              <label for="">Unidade de saúde</label>
              <vue-select
                :options="estabelecimentos"
                label="no_unidade_saude"
                placeholder=""
                v-model="form.estabelecimento"
                :loading="loadingSelectEstabelecimento"
                :disabled="loadingSelectEstabelecimento"
              >
                <template slot="option" slot-scope="option">
                  {{ option.no_unidade_saude }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
              <div class="error">{{ errors[0] }}</div>
            </validation-provider>
          </div>
          <div class="col-md-3">
            <validation-provider v-slot="{ errors }" rules="required">
              <label for="">Mês</label>
              <vue-select
                :options="monthOptions"
                label="label"
                placeholder=""
                v-model="form.mes"
                :clearable="false"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
              <div class="error">{{ errors[0] }}</div>
            </validation-provider>
          </div>
          <div class="col-md-2">
            <validation-provider
              v-slot="{ errors }"
              rules="required|onlyNumbers|ano"
            >
              <label for="">Ano</label>
              <input
                type="text"
                class="form-control"
                placeholder=""
                v-model="form.ano"
                v-inputmask="maskNumbers"
                maxlength="4"
              />
              <div class="error">{{ errors[0] }}</div>
            </validation-provider>
          </div>
          <div class="col-md-2 btn-filter">
            <button
              class="btn"
              type="button"
              :disabled="loading"
              @click="buscarDadosDia"
            >
              Buscar
              <b-spinner
                label="Spinning"
                small
                variant="white"
                v-if="loading"
              ></b-spinner>
            </button>
          </div>
        </div>
      </ValidationObserver>
      <div class="row mt-4">
        <div class="col-lg-12">
          <b-tabs
            fill
            class="esus-feedback-tabs tabs-auto"
            v-model="tabsActive"
          >
            <b-tab title="Dia" active @click="buscarDadosDia()">
              <template v-slot:title>
                <i class="icofont-list"></i> Dia
              </template>
              <div class="info-table py-4">
                <div class="info-table-item"></div>
                <div class="info-table-item">
                  <DownloadFiles
                    :pdfEnabled="false"
                    :callback-pdf="generatePdf"
                    :data="displayedDia"
                    :fields="dataFieldsDia"
                    name="atendimentos-classificacao-dia"
                  />
                </div>
              </div>
              <TabelaDia
                ref="table"
                :cadastros="displayedDia"
                :selectedEstabelecimento="form.estabelecimento"
                :loading="loading"
              />
            </b-tab>
            <b-tab title="Mês" @click="buscarDadosMes()">
              <template v-slot:title>
                <i class="icofont-list"></i> Mês
              </template>
              <div class="info-table py-4">
                <div class="info-table-item"></div>
                <div class="info-table-item">
                  <DownloadFiles
                    :pdfEnabled="false"
                    :callback-pdf="generatePdf"
                    :data="displayedMes"
                    :fields="dataFieldsMes"
                    name="atendimentos-classificacao-mes"
                  />
                </div>
              </div>
              <TabelaMes
                ref="table"
                :cadastros="displayedMes"
                :selectedEstabelecimento="form.estabelecimento"
                :loading="loading"
              />
            </b-tab>
            <b-tab title="Espera" @click="buscarDadosEspera()">
              <template v-slot:title>
                <i class="icofont-list"></i> Espera
              </template>
              <div class="info-table py-4">
                <div class="info-table-item"></div>
                <div class="info-table-item">
                  <DownloadFiles
                    :pdfEnabled="false"
                    :callback-pdf="generatePdf"
                    :data="displayedEspera"
                    :fields="dataFieldsEspera"
                    name="atendimentos-classificacao-espera"
                  />
                </div>
              </div>
              <TabelaEspera
                ref="table"
                :cadastros="displayedEspera"
                :selectedEstabelecimento="form.estabelecimento"
                :loading="loading"
              />
            </b-tab>
            <b-tab title="Classificação" @click="buscarDadosClassificacao()">
              <template v-slot:title>
                <i class="icofont-list"></i> Classificação
              </template>
              <div class="info-table py-4">
                <div class="info-table-item"></div>
                <div class="info-table-item">
                  <DownloadFiles
                    :pdfEnabled="false"
                    :callback-pdf="generatePdf"
                    :data="displayedClassificacao"
                    :fields="dataFieldsClassificacao"
                    name="atendimentos-classificacao"
                  />
                </div>
              </div>
              <TabelaClassificacao
                ref="table"
                :cadastros="displayedClassificacao"
                :selectedEstabelecimento="form.estabelecimento"
                :loading="loading"
              />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle.vue'
import Subtitle from './Subtitle.vue'
import * as Functions from './functions.js'
import {
  dataFieldsDia,
  dataFieldsMes,
  dataFieldsEspera,
  dataFieldsClassificacao,
} from './utils.js'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import TabelaDia from './TabelaDia.vue'
import TabelaMes from './TabelaMes.vue'
import TabelaEspera from './TabelaEspera.vue'
import TabelaClassificacao from './TabelaClassificacao.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
import Masks from '@/mixins/masks'
validations()

export default {
  name: 'AtendimentosClassificacao',
  props: {
    ajuda: {
      type: String,
      default: '',
    },
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    Subtitle,
    DownloadFiles,
    ValidationObserver,
    ValidationProvider,
    TabelaDia,
    TabelaMes,
    TabelaEspera,
    TabelaClassificacao,
  },
  mixins: [utils],
  data() {
    return {
      loadingSelectEstabelecimento: false,
      estabelecimentos: [],
      monthOptions: [
        { label: 'Janeiro', value: '01' },
        { label: 'Fevereiro', value: '02' },
        { label: 'Março', value: '03' },
        { label: 'Abril', value: '04' },
        { label: 'Maio', value: '05' },
        { label: 'Junho', value: '06' },
        { label: 'Julho', value: '07' },
        { label: 'Agosto', value: '08' },
        { label: 'Setembro', value: '09' },
        { label: 'Outubro', value: '10' },
        { label: 'Novembro', value: '11' },
        { label: 'Dezembro', value: '12' },
      ],
      loading: false,
      filterSearchTable: false,
      form: {
        estabelecimento: null,
        mes: null,
        ano: null,
      },
      tabsActive: 0,
      dadosDia: [],
      dadosMes: [],
      dadosEspera: [],
      dadosClassificacao: [],
      dataFieldsDia: { ...dataFieldsDia },
      dataFieldsMes: { ...dataFieldsMes },
      dataFieldsEspera: { ...dataFieldsEspera },
      dataFieldsClassificacao: { ...dataFieldsClassificacao },
    }
  },
  computed: {
    displayedDia() {
      if (this.filterSearchTable) return this.filterSearchTable
      return this.dadosDia || []
    },

    displayedMes() {
      if (this.filterSearchTable) return this.filterSearchTable
      return this.dadosMes || []
    },

    displayedEspera() {
      if (this.filterSearchTable) return this.filterSearchTable
      return this.dadosEspera || []
    },

    displayedClassificacao() {
      if (this.filterSearchTable) return this.filterSearchTable
      return this.dadosClassificacao || []
    },

    maskNumbers() {
      return Masks['number']
    },
  },
  methods: {
    /**
     * Buscar dados do dia
     */
    async buscarDadosDia() {
      try {
        this.tabsActive = 0

        this.dadosMes = []
        this.dadosEspera = []
        this.dadosClassificacao = []

        const isValid = await this.$refs.form.validate()
        if (!isValid) {
          return false
        }

        this.loading = true

        const response = await this.$api.get(
          `/app/atendimentos-classificacao/${this.$store.state.cod_ibge}/dia?mes=${this.form.mes.value}&ano=${this.form.ano}&cnes=${this.form.estabelecimento.nu_cnes}`
        )
        if (response) {
          this.dadosDia = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Buscar dados do mês
     */
    async buscarDadosMes() {
      try {
        if (this.dadosMes.length > 0) {
          return
        }

        this.loading = true

        const response = await this.$api.get(
          `/app/atendimentos-classificacao/${this.$store.state.cod_ibge}/mes?mes=${this.form.mes.value}&ano=${this.form.ano}&cnes=${this.form.estabelecimento.nu_cnes}`
        )
        if (response) {
          this.dadosMes = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Buscar dados da espera
     */
    async buscarDadosEspera() {
      try {
        if (this.dadosEspera.length > 0) {
          return
        }

        this.loading = true

        const response = await this.$api.get(
          `/app/atendimentos-classificacao/${this.$store.state.cod_ibge}/espera?mes=${this.form.mes.value}&ano=${this.form.ano}&cnes=${this.form.estabelecimento.nu_cnes}`
        )
        if (response) {
          this.dadosEspera = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Buscar dados da classificação
     */
    async buscarDadosClassificacao() {
      try {
        if (this.dadosClassificacao.length > 0) {
          return
        }

        this.loading = true

        const response = await this.$api.get(
          `/app/atendimentos-classificacao/${this.$store.state.cod_ibge}/classificacao?mes=${this.form.mes.value}&ano=${this.form.ano}&cnes=${this.form.estabelecimento.nu_cnes}`
        )
        if (response) {
          this.dadosClassificacao = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Gera o relatório em PDF.
     */
    generatePdf() {
      Functions.generatePdf(this.displayedCadastros, this.form)
    },

    /**
     * Carrega os estabelecimentos no select
     */
    async carregarSelectEstabelecimento() {
      try {
        this.loadingSelectEstabelecimento = true
        let response = await this.$api.get(
          `/app/relatorio-atendimentos/${this.$store.state.cod_ibge}/unidades-de-saude`
        )
        if (response) {
          this.estabelecimentos = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingSelectEstabelecimento = false
      }
    },
  },
  async created() {
    await this.carregarSelectEstabelecimento()
  },
}
</script>

<style lang="scss" scoped>
#atendimentos-classificacao {
  .btn-filter {
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }
}
</style>
